import $ from 'jquery';
import popper from 'popper.js';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import "./components/google-map";
import Splitting from "splitting";
import "./components/toggle-color-mode";
import "./components/restricted-access";
//import "splitting/dist/splitting.css";
//import "splitting/dist/splitting-cells.css";

let menu,
    toggleSearch,
    sitesearch,
    toggleMenu;

document.addEventListener('scroll', (e) => {
    let scrollValue = window.scrollY;
    let pageYOffset = window.pageYOffset;
    let logo =  document.querySelector('.logo');
    if (scrollValue > 50) {
        logo.classList.add('is-scrolled');
    } else {
        logo.classList.remove('is-scrolled');
    }
}, {passive: true})

const closeMenu = () => {
    if (menu.classList.contains('is-expanded')) {
        menu.classList.remove('is-expanded');
        toggleMenu.focus();
        return;
    };
   return;
}

const openMenu = (buttonTarget) => {
    if (buttonTarget !== null) {
        buttonTarget.toggleAttribute('aria-expanded');
    }
    menu.classList.toggle('is-expanded');
    document.body.classList.toggle('menu-is-open');

}

$(document).ready(function() {

    if (!$('#wrap table').hasClass('share-data-table')) {
        $('#wrap table').addClass('table table-striped');
        $("#wrap table tr:first-of-type td").each(function() {
            $(this).replaceWith('<th style="'+ $(this).attr("style") +'">' + $(this).text() + '</th>');
        });
        $('#wrap table tr:first-of-type').wrap('<thead class="thead-light"></div>')
        $('#wrap table .thead-light').insertBefore($('#wrap table tbody'));
        
        $('#wrap table').wrap('<div class="table-responsive"></div>');
    }
    
    menu = document.querySelector('.js-menu');
    toggleSearch = document.querySelector('.js-toggle-search');
    sitesearch = document.querySelector('#sitesearch');

    toggleMenu = document.querySelector('.js-toggle-menu');
    toggleMenu.addEventListener('click', (e) => {
        openMenu(toggleMenu);
    })

    toggleSearch.addEventListener('click', (e) => {
        openMenu(toggleSearch);
        sitesearch.focus();
    })

    menu.addEventListener('transitionend', (event) => {
        if(event.propertyName !== 'max-width') return;
        menu.classList.toggle('is-done-transitioning')
    })

    const qrSelect = document.querySelectorAll('.js-qr-select');
    qrSelect.forEach((s) => {

        s.addEventListener('change', function(e) {
            let target = e.target.options[e.target.options.selectedIndex].dataset.target;
            let parent = e.target.dataset.parent;
            target = '#' + target;
            let targets = `#${parent} .show`;
            targets = $(targets);

            
            $(targets).collapse('hide'); // hide all.
            setTimeout(() => {
                if (target !== null) {
                    $(target).collapse('show');
                }
            }, 200)
           
        })

    });
    
    // dom ready.
    Splitting();

    const animationBlocks = document.querySelectorAll('.js-trigger-animation');
    
    function handleIntersection(entries) {
    entries.map((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-loaded')
            observer.unobserve(entry.target);
        } else {
            entry.target.classList.remove('is-loaded') 
        }
    });
    }

    const observer = new IntersectionObserver(handleIntersection);
    if (animationBlocks.length > 0) {
        animationBlocks.forEach(image => observer.observe(image));
    }


Splitting();


    // Accordion
    $('.collapse').on('shown.bs.collapse', function(){
        $(this).parent().addClass("is-open");
        }).on('hidden.bs.collapse', function(){
        $(this).parent().removeClass("is-open");
    });

});